var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "eligibility", "data-cy": "component-eligibility" } },
    [
      _c("DebtorTags", {
        attrs: { "has-codebtor": _vm.simulation.prospect.hasCodebtor },
      }),
      _vm.policies && _vm.policies.length > 0
        ? _c(
            "div",
            _vm._l(_vm.policies, function (policy) {
              return _c(
                "div",
                {
                  key: policy.id,
                  staticClass: "bordered-bottom-box mb-1",
                  attrs: { "data-cy": `plcy-${policy.id}` },
                },
                [
                  _c("div", { staticClass: "eligibility-row" }, [
                    _c(
                      "a",
                      {
                        staticClass: "eligibility-label mr-2",
                        on: {
                          click: function ($event) {
                            return _vm.toggleComment(policy.id)
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: policy.showComment
                              ? "angle-down"
                              : "angle-right",
                          },
                        }),
                        _c("label", { staticClass: "label" }, [
                          _vm._v(_vm._s(policy.label)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "eligibility-options" },
                      _vm._l(_vm.radioOptions, function (option) {
                        return _c("PolicyRadioButton", {
                          key: `policy-${policy.id}-option-${option.value}`,
                          attrs: { option: option, name: `name-${policy.id}` },
                          on: {
                            input: function ($event) {
                              return _vm.showComment(policy.id)
                            },
                          },
                          model: {
                            value: policy.value,
                            callback: function ($$v) {
                              _vm.$set(policy, "value", $$v)
                            },
                            expression: "policy.value",
                          },
                        })
                      }),
                      1
                    ),
                  ]),
                  _c("b-collapse", { attrs: { open: policy.showComment } }, [
                    _c(
                      "div",
                      { staticClass: "comments my-1 ml-5 is-clearfix" },
                      [
                        _c("b-input", {
                          attrs: {
                            value:
                              policy.comment === "Evaluación automática"
                                ? ""
                                : policy.comment,
                            type: "textarea",
                            placeholder: "Agrega un comentario",
                          },
                          model: {
                            value: policy.comment,
                            callback: function ($$v) {
                              _vm.$set(policy, "comment", $$v)
                            },
                            expression: "policy.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            }),
            0
          )
        : _c("div", [
            _vm._v(" No hay criterios de elegibilidad para la evaluación"),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }